module.exports = __webpack_public_path__ + "img/bg02.b826ac0b.png";